
// GROUPED : Conveyancing-form

import { keys, reduce } from "lodash";
import { StageBConveyancing } from "../../../models/classes/stage-b/review-endorse.class";
import { validateConveyancingFields, validateLegalRepresentation, validateTenancyInCommon, validateTenancyInCommonTotalShares } from "../../validator";
import { SharedValidators } from "../shared/validators";


//=====
export const validateStageBConveyancing = (values: StageBConveyancing,  additional_values: any) => {
  const { isLoginOutgoing, isMainRetaining, isMainOutgoing, isRemission,  isProposedDirectConveyancing, isCurrentDirectConveyancing } = additional_values;
  const fields = keys(values);
  const errors: any = reduce( fields, (result, field: string) => {
      if(isMainRetaining && !isLoginOutgoing){
        //when is form 1 - DONE
        return { ...result, [field]: { isValid: true } };
      }
      else if(isMainOutgoing && !isLoginOutgoing){
        //DONE
        return validationCheckingForMainOutgoingAndLoginIncoming(values, result,field, isRemission, isCurrentDirectConveyancing, isProposedDirectConveyancing);
      }
      else if(values.proposed_same_solicitor && !isLoginOutgoing){
        //FORM 3 -- Validate proposed and documentation
        if( field === "proposed"){
          let validatedResult = validateLegalRepresentation(values, field, false);
          return { ...result, [field]: validatedResult };
        }
        else{
          return { ...result, [field]: { isValid: true } };
        }
      }
      else if(values.outgoing_different_solicitor){
        if( field === "outgoing"){
          let validatedResult = validateLegalRepresentation(values, field, false);
          return { ...result, [field]: validatedResult };
        }
        else if( field === "outgoing_solicitor_type") {
           return { ...result, [field]: SharedValidators.BasicEmptyUndefined(values[field])}
        }
        else{
          return { ...result, [field]: { isValid: true } };
        }
      }
      else{
        return { ...result, [field]: { isValid: true } };
      }
    },
    {}
  );
  return errors;
};


const validationCheckingForMainOutgoingAndLoginIncoming = (values:any, result:any, field:string, isRemission?:boolean, isCurrentDirectConveyancing?:boolean, isProposedDirectConveyancing?:boolean) => {
  
  //when direct conveyancing, then proposed_solicitor_type to be valid
  // if(isProposedDirectConveyancing && field === "proposed_solicitor_type"){
  //   return {...result, [field]: {isValid: true}};
  // }

  if((field === "is_holding_type_confirm" || field === "holding_type") || ( field === "proposed_solicitor_type" && !values.proposed_same_solicitor)){
    let validatedResult = validateConveyancingFields(values, field);
    return { ...result, [field]: validatedResult };
  }
  else if(field === "tenancy_in_common"){
    let validatedResult = validateTenancyInCommon(values, field);
    let validatedTotalSharesResult = validateTenancyInCommonTotalShares(values, field);
    return { ...result, ...validatedTotalSharesResult ,[field]: validatedResult };
  }
  
  if((field === "valuation" || field === "estimated_market_value") && !isRemission && !values.proposed_same_solicitor){
    let validatedResult = validateConveyancingFields(values, field);
    return { ...result, [field]: validatedResult };
  }
  else if( field === "proposed" && !values.proposed_same_solicitor){
    let validatedResult = validateLegalRepresentation(values, field, true);
    return { ...result, [field]: validatedResult };
  }
  else{
    return { ...result, [field]: { isValid: true } };
  }
}